import React, { memo, useEffect, useMemo, useState } from 'react';
import FastAboutContainer from './FastAbout/FastAboutContainer';
import FastPhotoContainer from './FastPhoto/FastPhotoContainer';
import FastContactsContainer from './FastContacts/FastContactsContainer';
import FastServicesContainer from './FastServices/FastServicesContainer';
import FastRulesContainer from './FastRules/FastRulesContainer';
import FastRoomsContainer from './FastRooms/FastRoomsContainer';
import FastPricesContainer from './FastPrices/FastPricesContainer';
import FastRoomEditContainer from './FastRoomEdit/FastRoomEditContainer';
import FastChooseCMContainer from './FastChooseCM/FastChooseCMContainer';
import Preloader from '../common/Preloader/Preloader';
import FastVerifiedContainer from './FastVerified/FastVerifiedContainer';
import { useDispatch } from 'react-redux';
import { TOGGLE_PHOTO_IS_DONE } from '../../globalState/app/constans';

const FastCreateObject = memo((props) => {
  const {
    objectId,
    description,
    photosToDB,
    owner,
    roomsListFromBd,
    userVerified,
    isPhotoDone,
    channelManager,
    hasCheckedServices,
    hasCheckedRules
  } = props;

  const dispatch = useDispatch();

  const [page, setPage] = useState('about');

  const pagesSubscriber = useMemo(() => {
    if (userVerified !== 'Y') return 'verified';

    if (!description) return 'about';

    if (!isPhotoDone) return 'photos';

    if (owner && owner.phones.length === 0) return 'contacts';

    if (!hasCheckedServices) return 'services';

    if (!hasCheckedRules) return 'rules';

    if (roomsListFromBd && roomsListFromBd.length === 0) return 'rooms';

    if (!channelManager) return 'cm';


    return 'calendar';

  }, [userVerified, description, isPhotoDone, owner, hasCheckedServices, hasCheckedRules, roomsListFromBd, channelManager]);


  useEffect(() => {
    if (pagesSubscriber) {
      setPage(pagesSubscriber);
    }
  }, [pagesSubscriber]);

  useEffect(() => {
    dispatch({ type: TOGGLE_PHOTO_IS_DONE, payload: photosToDB && (photosToDB.length >= 5) });
  }, [dispatch, photosToDB]);

  const goPage = (nextPage) => {
    setPage(nextPage);
  };


  const container = useMemo(() => {
    switch (page) {
      case 'about':
        return <FastAboutContainer goPage={goPage}/>;
      case 'photos':
        return <FastPhotoContainer goPage={goPage}/>;
      case 'contacts':
        return <FastContactsContainer goPage={goPage}/>;
      case 'services':
        return <FastServicesContainer goPage={goPage}/>;
      case 'rules':
        return <FastRulesContainer goPage={goPage}/>;
      case 'rooms':
        return <FastRoomsContainer goPage={goPage}/>;
      case 'roomEdit':
        return <FastRoomEditContainer goPage={goPage}/>;
      case 'cm':
        return <FastChooseCMContainer goPage={goPage}/>;
      case 'calendar':
        return <FastPricesContainer goPage={goPage}/>;
      default:
        return <FastVerifiedContainer goPage={goPage}/>
    }
  }, [page])

  if (!objectId) {
    return <Preloader loading={true}/>;
  }

  return (
    <div className='main ps-0'>
      <div className='container'>
        {container}
      </div>
    </div>
  );
});

export default FastCreateObject;
